import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvViasZonasPayload {
  via_id: number;
  codigo: string;
  nombre: string;
  tipo_zona: number;
  descripcion?: string | null;
  longitud_m?: number | null;
  ancho_m?: number | null;
  sentido_circulacion?: number | null;
  velocidad_maxima_kmh?: number | null;
  nivel_riesgo?: number | null;
  latitud?: number | null;
  longitud?: number | null;
  estado?: number;
  created_by?: number | null;
  updated_by?: number | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvViasZonas {
  id?: number;
  via_id: number;
  codigo: string;
  nombre: string;
  tipo_zona: number;
  descripcion?: string | null;
  longitud_m?: number | null;
  ancho_m?: number | null;
  sentido_circulacion?: number | null;
  velocidad_maxima_kmh?: number | null;
  nivel_riesgo?: number | null;
  latitud?: number | null;
  longitud?: number | null;
  estado: number;
  created_by?: number | null;
  updated_by?: number | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvViasZonasResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvViasZonasService {
  private readonly apiUrl = `${environment.apiUrl}/api/pesv_vias_zonas`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todas las zonas
   */
  getAll(): Observable<PesvViasZonas[]> {
    return this.http.get<PesvViasZonas[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener zona por ID
   */
  getById(id: number): Observable<PesvViasZonas> {
    return this.http.get<PesvViasZonas>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  getByIdZonas(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/zonas/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear zona
   */
  create(
    payload: PesvViasZonasPayload
  ): Observable<PesvViasZonasResponse> {
    return this.http.post<PesvViasZonasResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar zona
   */
  update(
    id: number,
    payload: Partial<PesvViasZonasPayload>
  ): Observable<PesvViasZonasResponse> {
    return this.http.put<PesvViasZonasResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar zona
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar zona
   */
  inactivar(id: number): Observable<PesvViasZonasResponse> {
    return this.http.put<PesvViasZonasResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar zona
   */
  activar(id: number): Observable<PesvViasZonasResponse> {
    return this.http.put<PesvViasZonasResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  getActiveVias(): Observable<PesvViasZonas[]> {
    return this.http.get<PesvViasZonas[]>(`${this.apiUrl}/zonas`, {
      withCredentials: true,
    });
  }
}